import { throwError as observableThrowError, Observable } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { CurrentUser } from '../models/current-user'
import { CurrentUserForESoa } from '../models/current-user-for-esoa'
import { UserAccessGateway } from './user-access-gateway'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { AuthenticationResult } from '../models/authentication-result'

@Injectable()
export class NetworkUserAccessGateway extends UserAccessGateway {
    constructor(private http: HttpClient) {
        super()
    }

    GetAdobeConfigurationFlag(): Observable<boolean> {
        let result = this.http.get<boolean>('../api/GetAdobeConfigurationFlag/')
        return result
    }

    //Load Adobe launch code
    LoadAdobeScript() {
        let body = <HTMLDivElement>document.body
        let script = document.createElement('script')
        script.innerHTML = ''
        let result
        this.GetAdobeConfigurationFlag().subscribe((data) => {
            if (data === true) {
                //If prod load prod script else staging one
                script.src = '//assets.adobedtm.com/9e9a5097b655/15c1dead6ee3/launch-51d691afcb33.min.js'
            } else {
                script.src = '//assets.adobedtm.com/9e9a5097b655/15c1dead6ee3/launch-30005d23b515-staging.min.js'
            }
        })

        script.async = true
        script.defer = true
        body.appendChild(script)
    }
    getCurrentUser(): Observable<CurrentUser> {
        return this.http.get<CurrentUser>('../api/currentuser').pipe(map((response) => response))
    }
    GetCurrentUserForESoa(): Observable<CurrentUserForESoa> {
        return this.http.get<CurrentUserForESoa>('../api/GetCurrentUserForESoa').pipe(map((response) => response))
    }

    checkAuthorizationForRoute(route: string, planyear: number,isMfaValidated:any): Observable<AuthenticationResult> {
        return this.http.get<AuthenticationResult>('../api/IsAuthenticated?route=' + route + '&selectedPlanyear=' + planyear + '&isMfaValidated=' + isMfaValidated).pipe(
            map((response) => response),
            catchError((error) => {
                return observableThrowError(error.json().redirectUrl)
            })
        )
    }

    checkSessionValid(): Observable<AuthenticationResult> {
        return this.http.get<AuthenticationResult>('../api/IsSessionValid')
    }

    getOrgId(): Observable<string> {
        return this.http.get<string>('../api/getUserOrg')
    }

    /*  getCurrentPlanYears(): Observable<number[]> {
        return this.http.get<any>('../api/GetCurrentPlanyear')
    } */
    getCurrentPlanYears(): Observable<number[]> {
        return this.http.get<any>('../api/GetCurrentPlanyear')
    }
    IsAllowtoAddUser(OrgId: number, userName: string): Observable<boolean> {
        let getURL = '../api/IsAllowtoAddUser/' + OrgId + '/' + userName
        return this.http.get<boolean>(getURL)
    }
    IsAllowtoEditUser(username: string): Observable<boolean> {
        let getURL = '../api/IsAllowtoEditUser/' + username
        return this.http.get<boolean>(getURL)
    }

    IsAllowtoEditAddOrg(username: string): Observable<boolean> {
        let getURL = '../api/IsAllowtoEditAddOrg/' + username
        return this.http.get<boolean>(getURL)
    }
    getcurrentPlanYearFromServer(): Observable<number> {
        return this.http.get<number>('../api/GetcurrentPlanYearFromServer')
    }
}
